import React, { forwardRef } from 'react';
import { AdBadge } from '../ad-badge';
import { BannerBlock, adBadge, bannerImg } from './styles';
import type { BannerProps } from './types';
import { styled } from 'linaria/react';

const WrapperComponent = styled.div``;

export const BannerComponent = forwardRef(
  (
    {
      imgSrc,
      target,
      children,
      isTokenExist = false,
      onClick,
      onMouseDown,
      onPointerUp,
      ...rest
    }: BannerProps & Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick' | 'onMouseDown' | 'onPointerUp'>,
    ref
  ) => {

    if (!imgSrc) return null;

    return (
      <BannerBlock ref={ref} {...rest}>
        <WrapperComponent onClick={onClick} onMouseDown={onMouseDown} onPointerUp={onPointerUp}>
          <a href={target}>
            <picture className={bannerImg}>
              <img srcSet={imgSrc} alt="Banner" />
            </picture>
          </a>
        </WrapperComponent>
        {isTokenExist && (
          <div className={adBadge}>
            <AdBadge variant="text">{children}</AdBadge>
          </div>
        )}
      </BannerBlock>
    );
  }
);
